import { render } from "./DashboardDesktop.vue?vue&type=template&id=56aba632"
import script from "./DashboardDesktop.vue?vue&type=script&lang=js"
export * from "./DashboardDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__